export default __webpack_public_path__ + "static/media/qr-code.a49db395.svg";